import {
  keepPreviousData,
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query'
import {
  getUserPayments,
  GetUserPaymentsOptions,
  GetUserPaymentsResponse,
} from 'api/payments'
import { paymentKeys } from './keys'

/**
 * Get a list of user payments that match the given filters
 * @example useUserPayments({ userId: 123, status: ['pending'] }, { retry: true })
 */
export function useUserPayments(
  /** Pass through to API */
  filters: GetUserPaymentsOptions,
  /** useQuery options */
  options?: Pick<
    Parameters<
      typeof useQuery<
        GetUserPaymentsResponse,
        Error,
        GetUserPaymentsResponse,
        ReturnType<typeof paymentKeys.search>
      >
    >[0],
    'retry' | 'initialData' | 'enabled' | 'placeholderData' | 'staleTime'
  >
): UseQueryResult<GetUserPaymentsResponse> {
  return useQuery({
    queryKey: paymentKeys.search(filters),
    queryFn: async () => getUserPayments(filters),
    retry: false,
    placeholderData: keepPreviousData,
    ...options,
  })
}
